import { makeAutoObservable, runInAction } from 'mobx';
import adminDashboardService from '../services/adminDashboardService';

class AdminDashboardStore {
  // State
  stats = null;
  recentActivity = [];
  loading = false;
  error = null;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  // Actions
  async fetchDashboardStats() {
    this.loading = true;
    this.error = null;

    try {
      const data = await adminDashboardService.getDashboardStats();

      runInAction(() => {
        this.stats = data;
        this.recentActivity = data.recent_activity || [];
        this.loading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.message || 'Failed to fetch dashboard statistics';
        this.loading = false;
      });
      throw error;
    }
  }

  // Computed values
  get totalUsers() {
    return this.stats?.users?.total || 0;
  }

  get totalProducts() {
    return this.stats?.products?.total || 0;
  }

  get awaitingMarketingCount() {
    return this.stats?.products?.awaiting_marketing || 0;
  }

  get totalRevenue() {
    return this.stats?.orders?.total_revenue || '0';
  }

  get totalOrders() {
    return this.stats?.orders?.total || 0;
  }

  get totalAppointments() {
    return this.stats?.appointments?.total || 0;
  }

  get totalPartners() {
    return this.stats?.partners?.total || 0;
  }

  get totalServices() {
    return this.stats?.services?.total || 0;
  }
}

export default AdminDashboardStore;
